/******************************************************************************
 * Created Date: Wednesday Feb 16 2022                                        *
 * Author: Patrick B.                                                         *
 * -----                                                                      *
 * Last Modified: Fri Feb 18 2022                                             *
 * Modified By: Patrick B.                                                    *
 * -----                                                                      *
 * File: /src/components/algorithms/quantification/PoiSelect                  *
 * Copyright (c) 2022 Kuva                                                    *
 ******************************************************************************/

import { useMemo } from "react";
import {
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Tooltip
} from "@mui/material";
import PropTypes from "prop-types";

const PoiSelect = ({
  pois,
  selectedPoi,
  setSelectedPoi,
  allowSelect,
  scanResults
}) => {
  const handleChange = event => {
    setSelectedPoi(event.target.value);
  };

  const totalScans = useMemo(() => {
    if (!scanResults?.length) {
      return 0;
    } else if (selectedPoi === "All") {
      return scanResults.length;
    } else {
      return scanResults.filter(scan => scan.poiOrientation === selectedPoi)
        .length;
    }
  }, [scanResults, selectedPoi]);

  return (
    <FormControl
      variant="standard"
      style={{
        display: "flex"
      }}
    >
      <Tooltip title={allowSelect ? "" : "Get Scans/POIs in order to select"}>
        <span>
          <InputLabel
            style={{
              fontSize: 14,
              width: "100%"
            }}
            id="poi-select-label"
          >
            {`POI SELECT (${totalScans} scans selected)`}
          </InputLabel>
          <Select
            variant="standard"
            id="poi-select"
            value={selectedPoi}
            label="POI"
            onChange={handleChange}
            disabled={!allowSelect}
          >
            {pois.map(poi => {
              return (
                <MenuItem key={poi} value={poi}>
                  {poi}
                </MenuItem>
              );
            })}
          </Select>
        </span>
      </Tooltip>
    </FormControl>
  );
};

PoiSelect.propTypes = {
  pois: PropTypes.array.isRequired,
  selectedPoi: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  setSelectedPoi: PropTypes.func.isRequired,
  allowSelect: PropTypes.bool.isRequired,
  scanResults: PropTypes.array.isRequired
};

export default PoiSelect;
